// Same word-stem matching as the backend term search: "Operating Instructions" ≈ "operating instruction(s)".
export const termRegex = (term) => {
  const words = (term || "").match(/[A-Za-z0-9]+/g);
  if (!words) return null;
  const stems = words.map((w) => {
    let s = w.toLowerCase();
    for (const suf of ["ing", "es", "ed", "s"]) {
      if (s.length > 4 && s.endsWith(suf)) { s = s.slice(0, -suf.length); break; }
    }
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\w{0,4}";
  });
  return new RegExp(`\\b(${stems.join("[\\s\\-]+")})\\b`, "gi");
};

export const Highlight = ({ text, term }) => {
  const rx = termRegex(term);
  if (!rx || !text) return text || null;
  return text.split(rx).map((chunk, i) =>
    i % 2 === 1 ? <mark key={i} className="bg-amber-200/80 text-inherit px-0.5">{chunk}</mark> : chunk);
};
